import ProductFormMixin from './ProductFormMixin';

export default {

	props: {
		value: {
			type: Object,
			required: true,
		},
		/** The form's $v validation object **/
		v: {
			type: Object,
			default: () => ({}),
		},
		submitAttempted: Boolean,
	},

	mixins: [ProductFormMixin],
};
